export default __webpack_public_path__ + "static/media/background4.1072d3e2.jpg";